import React from 'react';
import { Flex } from '@edreamsodigeo/prisma-design-system';
import Leg from '../Leg';
import { Maybe } from 'generated/graphql';

export type LegListProps = {
  legs?: Maybe<any>;
  isSem?: boolean;
  isAlternativeItinerary?: boolean;
};

const LegList: React.FC<LegListProps> = ({
  legs,
  isSem,
  isAlternativeItinerary,
}) => {
  return (
    <Flex flexGrow={1} flexDirection="column">
      {legs &&
        legs.map((leg, index) => (
          <Flex
            key={index}
            flexGrow={1}
            justifyContent="space-between"
            mt={index > 0 ? 'base' : null}
          >
            <Leg
              leg={leg}
              id={index}
              isSem={isSem}
              isAlternativeItinerary={isAlternativeItinerary}
            />
          </Flex>
        ))}
    </Flex>
  );
};

export default LegList;
